import React, { useEffect, useRef, useState } from 'react';
import * as PropTypes from 'prop-types';
import { Button, Col, Row } from 'react-bootstrap';
import { Form, Formik } from 'formik';
import { useParams } from 'react-router-dom';
import { FormDatePickerField, FormInputField } from '../../common/components/formFields';
import DealersSelectField from '../../dealers/forms/DealersSelectField';
import LocationsSelectField from '../../locations/forms/LocationsSelectField';
import ComponentCard from '../../common/components/cards/ComponentCard';
import validationSchema from './TransactionsSearch.schema';

const initialValues = {
  search: '',
  feeInPence: '',
  dealerId: '',
  organizationLocationId: '',
  transactionDateFrom: '',
  transactionDateTo: '',
};

function TransactionsSearch({ onSearch, dealerName }) {
  const { dealerId } = useParams();
  const formRef = useRef();
  const [reloadDatePickerKey, setReloadDatePickerKey] = useState(false);

  useEffect(() => {
    if (dealerName && formRef.current) {
      const dealerOption = { value: dealerId, label: dealerName };
      formRef.current.setFieldValue('dealerId', dealerOption);
    }
  }, [dealerName, dealerId]);

  const handleClearButtonClick = (resetForm, submitForm) => {
    setReloadDatePickerKey((prevState) => !prevState);
    resetForm();

    if (dealerName && formRef.current) {
      const dealerOption = { value: dealerId, label: dealerName };
      formRef.current.setFieldValue('dealerId', dealerOption);
    }

    submitForm();
  };

  return (
    <ComponentCard title="Search Transactions" isCollapsible>
      <Formik
        innerRef={formRef}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSearch}
        validateOnBlur
      >
        {({ values, resetForm, submitForm, setFieldValue }) => (
          <Form noValidate className="search-form-compact">
            <Row>
              <Col md="4">
                <FormInputField name="search" label="Title" />
              </Col>
              <Col md="4">
                <DealersSelectField
                  name="dealerId"
                  label="Dealer"
                  disabled={!!dealerName}
                  onChangeHandler={() => setFieldValue('organizationLocationId', null)}
                />
              </Col>
              <Col md="4">
                <LocationsSelectField
                  name="organizationLocationId"
                  label="Location"
                  organizationId={values.dealerId?.value || null}
                  disabled={!values.dealerId?.value}
                />
              </Col>
            </Row>
            <Row>
              <Col md="4">
                <FormInputField name="feeInPence" label="Fee" />
              </Col>
              <Col md="4">
                <FormDatePickerField
                  name="transactionDateFrom"
                  label="Transaction Date From"
                  key={reloadDatePickerKey}
                />
              </Col>
              <Col md="4">
                <FormDatePickerField
                  name="transactionDateTo"
                  label="Transaction Date To"
                  key={reloadDatePickerKey}
                  isUpperRange
                />
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Button className="mt-4 float-end ms-2 rounded-pill btn-primary" type="submit">
                  Search
                </Button>
                <Button
                  className="mt-4 float-end rounded-pill btn-soft-primary"
                  type="button"
                  onClick={() => handleClearButtonClick(resetForm, submitForm)}
                >
                  Clear
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </ComponentCard>
  );
}

TransactionsSearch.propTypes = {
  onSearch: PropTypes.func.isRequired,
  dealerName: PropTypes.string,
};

TransactionsSearch.defaultProps = {
  dealerName: null,
};

export default TransactionsSearch;
